import * as moment from 'moment';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: false,
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | string): string {
    const isValid = moment.utc(value, moment.ISO_8601, true).isValid();
    return isValid ? moment.utc(value).fromNow() : '';
  }
}
